import React, { useEffect } from "react";
import nextId from "react-id-generator";
import { Images } from "../../../Assets/0a-exporter";
import HoverDropdown from "../../Common/HoverDropdown/HoverDropdown";
import "./smart-match.style.scss";
const SmartMatchApplicant = ({ setRouteTitle }) => {
  useEffect(() => {
    setRouteTitle("View Applicants");
  }, []);
  return (
    <div className="applicants-table-main">
      <header className="atm-header">
        <div className="atmh-left">
          <h5>Total Applicants</h5>
        </div>
        <div className="atmh-right">
          <div className="atm-search">
            <img src={Images.graySearch} />
            <input />
          </div>
          <HoverDropdown title="sort" message="Older-newest" />
        </div>
      </header>
      <div className="atm-table-wrapper">
        <div className="atm-table-header">
          {headerList.map((obj) => (
            <h6 key={obj.keyId}>{obj.name}</h6>
          ))}
        </div>

        <div className="atm-table-body">
          {[1, 2, 3, 4, 5, 6].map((obj) => (
            <div className="atm-table-row-wrapper">
              <div className="atm-table-row">
                <div className="candidate-info each-cell">
                  <span>
                    <img src={Images.menTree} />
                  </span>
                  <div>
                    <h5>Jany Doe johnson</h5>
                    <p>102201</p>
                  </div>
                </div>
                <div className="each-cell">
                  <p>6.5 yrs</p>
                </div>
                <div className="each-cell">
                  <p>26/07/2021</p>
                </div>
                <div className="each-cell">
                  <p>Yes</p>
                </div>
                <div className="each-cell">
                  <div className="cell-dropdown">
                    <h6 className="cd-selected">Interview in progress</h6>
                    <div></div>
                  </div>
                </div>
                {/* <div className="each-cell">
                  <button>
                    <img src={Images.cvBorderLogo} />
                  </button>
                  <button>
                    <img src={Images.penPage} />
                  </button>
                  <button onClick={() => setOpenPreview(true)}>
                    View Details
                  </button>
                </div> */}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
const headerList = [
  { keyId: nextId(), name: "Applicants name" },
  { keyId: nextId(), name: "Exp (IN YRS)" },
  { keyId: nextId(), name: "Applied date" },
  { keyId: nextId(), name: "B.ed Certified" },
  { keyId: nextId(), name: "Status" },
  //   { keyId: nextId(), name: "Actions" },
];

export default SmartMatchApplicant;
